<template>
  <picker-field :label="label" :display="display" :value="value" ref="picker" @open="onSearch">
    <div class="list">
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="select(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.mk_name}}</p>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
      </div>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";

export default {
  components: {
    PickerField
  },
  props: {
    label: {
      type: String,
      default: "制造类型"
    },
    path: {
      type: String
    },
    value: String
  },
  data() {
    return {
      display: null,
      items: []
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.mk_name);
      me.$emit("select", item);
      me.display = item.mk_name;
      me.$refs.picker.close();
    },
    onSearch() {
      var me = this;
      me.$loading({
        url: "/api/make/kind/listbytype" + me.path,
        params: {
          number: 1,
          size: 100
        }
      }).then(function(res) {
        if (res.success) {
          me.items = res.data || [];
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    }
  }
};
</script>